import React from 'react';
import { Field, ErrorMessage } from 'formik';

import { StyledTableDataContents, StyledTableDataLabel } from './styled';

type SerialNumberInputRowProps = {
  inputName: string;
};

const SerialNumberInputRow: React.FC<SerialNumberInputRowProps> = ({
  inputName,
}) => (
    <tr>
      <StyledTableDataLabel textAlignTop>
        <label>Serial #: </label>
      </StyledTableDataLabel>
      <StyledTableDataContents flexCol>
        <Field
          autoComplete="off"
          type="text"
          className="form-control"
          name={inputName}
        />
        <ErrorMessage name={inputName} component="label" className="error" />
      </StyledTableDataContents>
    </tr>
  );

export default SerialNumberInputRow;
